export const getSelectScriptColumns = script => {
  const scriptSemLineBreaks = script.replace(/[\r\n]/gm, ' ');

  return /(?:select)(.*?)(?=from)/i.exec(scriptSemLineBreaks);
};
